import React from "react"
import { AuthenticationLayout } from "layoutsV2/client/AuthenticationLayout"
import { SignIn as SingInForm } from "ui/auth/SignIn"

export const SignIn = () => (
  <AuthenticationLayout type="signin">
    <SingInForm />
  </AuthenticationLayout>
)
